import PricingCards from '../Pricing/PricingCard';
import { HomePagePricingPlans } from '../../store/Utility/Utility';

function Services() {
    const gototop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }
    return (
        <>
            <section>
                <PricingCards pricingPlans={HomePagePricingPlans} />
            </section>
        </>
    )
}

export default Services
